module.exports = __webpack_public_path__ + "e8425182de1b7c8ebc3efbfee7fc926b.png";